exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1mPK4ViWYBisPc{background:#eb5a46!important}._1mPK4ViWYBisPc:hover{background:#cf513d!important}.Gk3L9oaMa7hyD9,.Gk3L9oaMa7hyD9:focus{background-color:#00c2e0}.Gk3L9oaMa7hyD9:active,.Gk3L9oaMa7hyD9:hover{background-color:#00aecc}", ""]);

// exports
exports.locals = {
	"newNotifications": "_1mPK4ViWYBisPc",
	"hasOtherNotifications": "Gk3L9oaMa7hyD9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/header/notifications-menu-button/styles.less
// module id = a632
// module chunks = 24